import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/*
 * HelpToggle — a small eye button that shows or hides explanatory text, so a
 * screen stays clean until somebody asks what something means.
 */

export const HelpToggle: React.FC<{
  label?: string;
  className?: string;
  children: React.ReactNode;
}> = ({ label = 'What these mean', className = '', children }) => {
  const [open, setOpen] = useState(false);
  let Icon = Eye;
  if (open) Icon = EyeOff;
  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="inline-flex items-center gap-1.5 rounded-act px-1.5 py-1 text-[12px] font-medium text-ink-muted transition-colors hover:bg-canvas-inset hover:text-ink"
      >
        <Icon size={14} />
        {label}
      </button>
      {open && <div className="mt-2">{children}</div>}
    </div>
  );
};
